import { render, staticRenderFns } from "./clue-recommend.vue?vue&type=template&id=071d1453&scoped=true&"
import script from "./clue-recommend.vue?vue&type=script&lang=js&"
export * from "./clue-recommend.vue?vue&type=script&lang=js&"
import style0 from "./clue-recommend.vue?vue&type=style&index=0&id=071d1453&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d1453",
  null
  
)

export default component.exports